export function generateBaseUrl(userId, page, searchString, referer): string {
    return `/users/${userId}/personal?referer=${referer}&page=${page}${searchString !== '' ? `&search=${searchString}` : ''}`
}